/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
==========================================================================================*/
import MsButton from '@/components/button/MsButton.vue';
import MsSplitButton from '@/components/button/MsSplitButton.vue';
import MsDropDownButton from '@/components/button/MsDropDownButton.vue';
import MsInput from '@/components/input/MsInput.vue';
import MsCheckbox from '@/components/checkbox/MsCheckbox.vue';
import MsRadio from '@/components/radio/MsRadio.vue';
import MsResizeWrapper from '@/components/resize-wrapper/MsResizeWrapper.vue';
import MsDatepicker from '@/components/datepicker/MsDatePicker.vue';
import MsDatePickerButton from '@/components/datepicker/MsDatePickerButton.vue';
import MsColorPicker from '@/components/colorpicker/MsColorPicker.vue';
import MsElementCombobox from '@/components/elementCombobox/MsElementCombobox.vue';
import MsTextarea from '@/components/textarea/MsTextarea.vue';
import MsIcon from '@/components/icon/MsIcon.vue';
// import VTooltip from "@/components/tooltip";
import MsNumber from '@/components/number/MsNumber.vue';
import MsComboBox from '@/components/combobox/MsCombobox.vue';
import MsComboboxEnum from '@/components/combobox/MsComboboxEnum.vue';
import MsDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import MsGridViewer from '@/components/gridViewer/MsGridViewer.vue';
import MsChart from '@/components/chart/MsChart.vue';
import MsDependencyLibs from '@/components/base/MsDependencyLibs.vue';

// Khởi tạo các component này khi chạy app để khi mất mạng vẫn đáp ứng mở được form
import DefaultTabOffline from '@/views/voucherOffline/DefaultTabOffline.vue';

//import ProcessTreasury from '@/views/treasury/processTreasury/ProcessTreasury.vue';
import BUPlanWithdrawCashDetail from '@/views/treasury/budgetPlanWithDraw/BUPlanWithdrawCashDetail.vue';
import BUPlanWithdrawDepositDetail from '@/views/treasury/budgetPlanWithDraw/BUPlanWithdrawDepositDetail.vue';
import BUTransferDepositDetail from '@/views/treasury/bUTransfer/BUTransferDepositDetail.vue';

//import ProcessDeposits from '@/views/deposits/processDeposits/ProcessDeposits.vue';
import BAWithDrawDetail from '@/views/deposits/bAWithDraw/BAWithDrawDetail.vue';

//import ProcessCash from '@/views/cash/processCash/ProcessCash.vue';
import CAReceiptDetail from '@/views/cash/CAReceipt/CAReceiptDetail.vue';
import CAPaymentDetail from '@/views/cash/CAPayment/CAPaymentDetail.vue';

// import ProcessSummary from '@/views/summary/processSummary/ProcessSummary.vue';
// import ProcessSummaryDiary from '@/views/summary/processSummary/ProcessSummaryDiary.vue';
// import ProcessSummaryDiaryBook from '@/views/summary/processSummary/ProcessSummaryDiaryBook.vue';
import GLGeneralVoucherDetail from '@/views/summary/gLVoucher/GLVoucherDetail.vue';

import ListVoucherOffline from '@/views/voucherOffline/ListVoucherOffline.vue';
import ReportOfflineDesigner from '@/views/report/ReportOfflineDesigner.vue';
import C408_KB_TT19 from '@/views/report/parameters/voucherReport/C408_KB_TT19.vue';
import ReportParamAccountVoucher_Offline from '@/views/report/parameters/offlineReport/ReportParamAccountVoucher_Offline.vue';
// In bảng kê offline
import PaymentVoucherListPrintFromVoucher_ND11_2020_vertical_offline from '@/views/report/parameters/offlineReport/PaymentVoucherListPrintFromVoucher_ND11_2020_vertical_offline.vue';

import C202aNSND112020_WithBankAccount_Offline from '@/views/report/parameters/voucherReport/C202aNSND112020_WithBankAccount_Offline.vue';
import C202bNSND112020_WithBankAccount_Offline from '@/views/report/parameters/voucherReport/C202bNSND112020_WithBankAccount_Offline.vue';
export function useComponents(app) {
  app.component(MsButton.name, MsButton);
  app.component(MsSplitButton.name, MsSplitButton);
  app.component(MsDropDownButton.name, MsDropDownButton);
  app.component(MsInput.name, MsInput);
  app.component(MsCheckbox.name, MsCheckbox);
  app.component(MsRadio.name, MsRadio);
  app.component(MsResizeWrapper.name, MsResizeWrapper);
  app.component(MsDatepicker.name, MsDatepicker);
  app.component(MsDatePickerButton.name, MsDatePickerButton);
  app.component(MsColorPicker.name, MsColorPicker);
  app.component(MsElementCombobox.name, MsElementCombobox);
  app.component(MsTextarea.name, MsTextarea);
  app.component(MsIcon.name, MsIcon);

  app.component(MsNumber.name, MsNumber);
  app.component(MsComboBox.name, MsComboBox);
  app.component(MsComboboxEnum.name, MsComboboxEnum);
  app.component(MsDynamicPopup.name, MsDynamicPopup);
  app.component(MsGridViewer.name, MsGridViewer);
  app.component('MsChart', MsChart);
  app.component('MsDependencyLibs', MsDependencyLibs);

  // Khởi tạo các component này khi chạy app để khi mất mạng vẫn đáp ứng mở được form
  app.component(DefaultTabOffline.name, DefaultTabOffline);

  //app.component(ProcessTreasury.name, ProcessTreasury);
  app.component(BUPlanWithdrawCashDetail.name, BUPlanWithdrawCashDetail);
  app.component(BUPlanWithdrawDepositDetail.name, BUPlanWithdrawDepositDetail);
  app.component(BUTransferDepositDetail.name, BUTransferDepositDetail);

  //app.component(ProcessDeposits.name, ProcessDeposits);
  app.component(BAWithDrawDetail.name, BAWithDrawDetail);

  //app.component(ProcessCash.name, ProcessCash);
  app.component(CAReceiptDetail.name, CAReceiptDetail);
  app.component(CAPaymentDetail.name, CAPaymentDetail);

  // app.component(ProcessSummary.name, ProcessSummary);
  // app.component(ProcessSummaryDiary.name, ProcessSummaryDiary);
  // app.component(ProcessSummaryDiaryBook.name, ProcessSummaryDiaryBook);
  app.component(GLGeneralVoucherDetail.name, GLGeneralVoucherDetail);

  app.component(ListVoucherOffline.name, ListVoucherOffline);
  app.component(ReportOfflineDesigner.name, ReportOfflineDesigner);
  app.component(C408_KB_TT19.name, C408_KB_TT19);
  app.component(ReportParamAccountVoucher_Offline.name, ReportParamAccountVoucher_Offline);
  app.component(PaymentVoucherListPrintFromVoucher_ND11_2020_vertical_offline.name, PaymentVoucherListPrintFromVoucher_ND11_2020_vertical_offline);
  app.component(C202aNSND112020_WithBankAccount_Offline.name, C202aNSND112020_WithBankAccount_Offline);
  app.component(C202bNSND112020_WithBankAccount_Offline.name, C202aNSND112020_WithBankAccount_Offline);
}
